module["exports"] = ["Україна"];